import * as React from "react";
import { FieldValueCollection } from "typings/index";
import { BaseFieldEditor } from "../helper";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { getCollections } from "~/state/action";
import styled from "styled-components";
import CollectionPickerDialog from "./CollectionPickerDialog";
import { Link } from "react-router-dom";
import { DefaultButton } from "office-ui-fabric-react";

export interface Props extends BaseFieldEditor
{
    value: FieldValueCollection;
    placeholder?: string;
}

const  CollectionList = styled.div`
    background: white;
    padding: 10px;
    button{
        margin-top: 10px;
    }
    a{
        margin: 0px 20px 10px 0;
    }
    
`;

const Collection: React.FunctionComponent<Props & StateProps> = props =>
{
    const [showCollectionPickerDialog, setShowCollectionPickerDialog] = React.useState<boolean>(false);
    const [collections, setCollection] = React.useState<string[]>(props.value && props.value.value || []);
    const toggleCollectionPickerDialog = () => setShowCollectionPickerDialog(!showCollectionPickerDialog);
    
    const onSave = () =>
    {
        const fieldValue: FieldValueCollection= { ...props.value, value: collections };
        props.onValueChange(fieldValue);
        setShowCollectionPickerDialog(false);
    };

    const renderCollection = () =>
    {
        if (props.value && props.value.value)
        {
            return props.value.value.map((id, index) =>
            {
                const collection = props.collections.find(x => x.id === id );
                if (collection)
                {
                    return <Link to={`/collections/${id}`}>
                        {collection.name}
                    </Link> ;
                }
            });
        }
        
    };

    const addOrRemoveFromCollection = (id: string) => 
    {
        const newCollection = collections.indexOf(id) === -1 ? [...collections, id] : collections.filter(x => x !== id);
        setCollection(newCollection);
    };

    const dialog = () =>
    {
        if (showCollectionPickerDialog)
        {
            return <CollectionPickerDialog {...props}
                onDismissClick={toggleCollectionPickerDialog}
                addOrRemoveFromCollection={addOrRemoveFromCollection}
                onSave={onSave}
                selectedCollections={collections} />;
        }
    };

    return (
        <CollectionList>
            {renderCollection()}
            <br></br>
            <DefaultButton 
                text="Add or Edit Collection"
                disabled={props.disabled} 
                iconProps={{iconName: "Add"}} 
                onClick={toggleCollectionPickerDialog} 
            />
            {dialog()}
        </CollectionList>
    );
    
};



const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    return {
        collections: getCollections(state)
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
   
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(Collection);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/collectionPicker/index.tsx